import React from 'react';

interface CheckMarkProps {
  color?: string;
  width?: number;
  height?: number;
}

const CheckMark: React.FC<CheckMarkProps> = ({
    color = '#414141',
    width = 12,
    height = 12
}) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 9 7"
            fill="none"
        >
            <path
                d="M3.05052 6.21266C2.88458 6.21266 2.71864 6.14946 2.59174 6.02257L0.189959 3.62078C-0.0633197 3.36751 -0.0633197 2.95651 0.189959 2.70323C0.443238 2.44995 0.854239 2.44995 1.10752 2.70323L3.05052 4.64623L7.50679 0.189959C7.76007 -0.0633197 8.17107 -0.0633197 8.42435 0.189959C8.67763 0.443238 8.67763 0.854239 8.42435 1.10752L3.5093 6.02257C3.3824 6.14946 3.21646 6.21266 3.05052 6.21266Z"
                fill={color}
            />
        </svg>
    );
};

export default CheckMark;
